import { useEffect, useRef } from 'react'

export const useAbortController = () => {
  const controllerRef = useRef(new AbortController())

  useEffect(() => {
    return () => {
      controllerRef.current.abort()
    }
  }, [])

  const abortAndReplace = () => {
    controllerRef.current.abort()
    const newController = new AbortController()
    controllerRef.current = newController
    return newController
  }

  return {
    controller: controllerRef.current,
    abortAndReplace
  }
}
